"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOP_AREA_NAVIGATION = exports.BURGER_MENU = void 0;
const TOP_AREA_NAVIGATION = exports.TOP_AREA_NAVIGATION = 'top-area-navigation';
const BURGER_MENU = exports.BURGER_MENU = 'burger-menu';